import axios, { AxiosResponse } from 'axios';
import urlConfig from './urlConfig';
import router from '@/router';
import { ElMessage} from 'element-plus'
import { getToken } from '@/utils/cookies'
import { axiosOptions } from '@/constant/axios'
import {repetitionApiList} from '@/constant/whitelist'
import Cookies from 'js-cookie'
import { handleMigrationResponse } from '@/utils/migration'

const axiosInstanceNormal = axios.create();
const axiosInstanceUpload = axios.create();
const axiosInspectopen = axios.create(); //天虹巡课
const axiosFrontDesk = axios.create(); //请求前台接口
export interface responseData<t = any> {
  readonly code: number;
  readonly data: t;
  readonly message: string;
  readonly status: 0 | 1 | 2 | 200;
}
let pending:any = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;

export function removePending (config:any) {
    for(let p in pending){
        if(pending[p].u === config.url + '&' + config.method) { //当前请求在数组中存在时执行函数体
            pending[p].f(); //执行取消操作
            pending.splice(p, 1); //把这条记录从数组中移除
        }
    }
    
}
export function getRandBaseUrl(){
  if(urlConfig.apirUrlList!=undefined && urlConfig.apirUrlList!=null){
    let count = urlConfig.apirUrlList.length-1;
    if(count>0){
      //随机取出一个域名用来请求
      let randIndex = Math.floor(Math.random()*count);
      let tmpUrl = urlConfig.apirUrlList[randIndex];
      if(tmpUrl != "" && tmpUrl !=null && tmpUrl.length>0){
        return tmpUrl;
      }
    }
  }
  return urlConfig.httpRequestUrl;
}

axiosInstanceNormal.defaults.adapter = require('axios/lib/adapters/http');
// 请求超时时间
axiosInstanceNormal.defaults.timeout = 900000;
// 白名单配置
axiosInstanceNormal.defaults.withCredentials = false;
// post请求头
axiosInstanceNormal.defaults.headers['Content-Type'] = 'application/json';
// 请求拦截器
axiosInstanceNormal.interceptors.request.use((config:any) => {
    config.headers.token = getToken() || Cookies.get('portal-token') || '';
    removePending(config); //在一个ajax发送前执行一下取消操作
    if(repetitionApiList.includes(config.url)){ //白名单配置，默认都需要重复提交判定
      config.cancelToken = new cancelToken((c:any)=>{
        // 这里的ajax标识我是用请求地址&请求方式拼接的字符串
        pending.push({ u: config.url + '&' + config.method, f: c }); 
      });
    }
    return config;
  },
  (e:any) => {
    console.log(e);
  }
);

axiosInstanceNormal.interceptors.response.use(
  (response:any) =>{
   removePending(response.config)
   return Promise.resolve(response)  
  },
  (error:any) => Promise.reject(error)
);

//天虹请求配置
axiosInspectopen.defaults.adapter = require('axios/lib/adapters/http');
// 请求超时时间
axiosInspectopen.defaults.timeout = 60000;
// 白名单配置
axiosInspectopen.defaults.withCredentials = false;
// post请求头
axiosInspectopen.defaults.headers['Content-Type'] = 'application/json';
//私有访问网络访问
//axiosInspectopen.defaults.headers['Access-Control-Request-Private-Network'] = 'true';
axiosInspectopen.interceptors.response.use(
  (response: any) =>
  Promise.resolve(response),
  (error:any) => Promise.reject(error)
);


// 上传实例
axiosInstanceUpload.defaults.baseURL = urlConfig.httpRequestUrl;
// 请求超时时间
axiosInstanceUpload.defaults.timeout = 900000;
// 白名单配置
axiosInstanceUpload.defaults.withCredentials = false;
// post请求头
axiosInstanceUpload.defaults.headers['Content-Type'] = 'multipart/form-data';
// 请求拦截器
axiosInstanceUpload.interceptors.request.use(
  (config:any) => { config.headers.token = getToken() || '';
    return config;
  }, (e:any) => {
    console.log(e);
  }
);
// 响应拦截器
axiosInstanceUpload.interceptors.response.use(
  (response: any) => Promise.resolve(response), // 这里使用断言
  (error:any) => Promise.reject(error)
);


/**
 * post，主要用于代码提示
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 * @param showError [显示错误]
 */

const post = <t>(url: string, params: object, axiosoptions?:axiosOptions): Promise<t> =>
  axiosInstanceNormal.post(getRandBaseUrl()+url, params).then((res:any) => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 1 || responseData.status === 200) {
        const data = responseData.data as t;
        return Promise.resolve(data);
      }
      // 学校迁移交割期：不弹普通错误，直接跳转拦截页
      if (handleMigrationResponse(responseData as any)) {
        return Promise.reject(responseData);
      }
      // 后端接口通了，但是报错
      if (axiosoptions == null || axiosoptions.showErr == true) {
        ElMessage({ type: "error", message: responseData.message});
      }
      if(axiosoptions && axiosoptions.allData){
        let responseData = res.data as t;
        return Promise.resolve(responseData);
      }
      return Promise.reject(responseData);
    }).catch((e:any) => Promise.reject(e));

/*
 * get
 * @param url 请求地址
 * @param params 请求参数
 * */
const get = <t>(url: string, params?: object, showError = true): Promise<t> =>
  axiosInstanceNormal.get(getRandBaseUrl()+url, {params}).then((res:any) => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 1 || responseData.status === 200) {
        const data = responseData.data as t;
        return Promise.resolve(data);
      }
      // 学校迁移交割期：不弹普通错误，直接跳转拦截页
      if (handleMigrationResponse(responseData as any)) {
        return Promise.reject(responseData);
      }
      if (showError) {
        ElMessage({ type: "error", message: responseData.message});
      }
      return Promise.reject(responseData);
    })
    .catch((e:any) => Promise.reject(e));

/**
 * postInspect，第三方接口请求
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 * @param showError [显示错误]
 */

 const postInspect = <t>(url: string, params?: object, showError = true): Promise<t> =>
 axiosInspectopen.post(url, params).then((res:any) => {
     const responseData = res.data as any;
     if (responseData.success || responseData.status == 1) {
       const data = responseData as t;
       return Promise.resolve(data);
     }
     // 后端接口通了，但是报错
     if (showError) {
       ElMessage({ type: "error", message: responseData.message});
     }
     return Promise.reject(responseData);
   })
   .catch((e:any) => Promise.reject(e));
/*
 * getInspect 天虹巡课第三方接口
 * @param url 请求地址
 * @param params 请求参数
 * */
const getInspect = <t>(url: string, params?: object, showError = true): Promise<t> =>
axiosInspectopen.get(url, {params}).then((res:any) => {
      const responseData = res.data as any;
      if (responseData.success) {
        const data = responseData as t;
        return Promise.resolve(data);
      }
      if (showError) {
        ElMessage({ type: "error", message: responseData.message});
      }
      return Promise.reject(responseData);
    })
    .catch((e:any) => Promise.reject(e));
/*
 * upload
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 */
const upload = <t>(url: string, params: any): Promise<t> =>
  axiosInstanceUpload
    .post(url, params)
    .then((res:any) => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 1) {
        const data = responseData.data as t;
        return Promise.resolve(data);
      }
      if (handleMigrationResponse(responseData as any)) {
        return Promise.reject(responseData);
      }
      ElMessage({ type: "error", message: responseData.message});
      return Promise.reject(responseData);
    })
    .catch((e:any) => Promise.reject(e));

const uploadSplice = <t>(url: string, param: FormData): Promise<responseData<t>> => {
  return axiosInstanceUpload
    .post(url, param)
    .then((res:any) => {
      const responseData = res.data as responseData<t>;
      if (responseData.status === 0) {
        ElMessage({ type: "error", message: responseData.message});
      }
      return Promise.resolve(responseData);
    })
    .catch((e:any) => Promise.reject(e));
};


//访问前台接口
axiosFrontDesk.defaults.baseURL = urlConfig.wechatUrl;
axiosFrontDesk.defaults.adapter = require('axios/lib/adapters/http');
/**
 * post，主要用于代码提示
 * @param url [请求的url地址]
 * @param params [请求时携带的参数]
 * @param showError [显示错误]
 */

 const frontDeskPost = <t>(url: string, params?: object, showError = true): Promise<t> =>
 axiosFrontDesk.post(url, params).then((res:any) => {
     const responseData = res.data as responseData<t>;
     if (responseData.status === 1 || responseData.status === 200) {
       const data = responseData.data as t;
       return Promise.resolve(data);
     }
     // 后端接口通了，但是报错
     if (showError) {
       ElMessage({ type: "error", message: responseData.message});
     }
     return Promise.reject(responseData);
   }).catch((e:any) => Promise.reject(e));
export { post, get, upload, uploadSplice, postInspect, getInspect, frontDeskPost};
